module.exports = __webpack_public_path__ + "static/media/37f9f3e8f9d4002c68ba496da97fa2fb.w750.h750.941b86e0.jpg";